<template>
    <ProductBox :modeljson="modeljson" :stringsjson="stringsjson" mode="content" />
</template>

<script>
    import ProductBox from '../buyenergyheader/ProductBox'

    export default {
        props: {
            modeljson: String,
            stringsjson: String
        },
        components: {
            ProductBox
        }
    };
</script>